import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../modules/security/service/auth.service';
import { UsersService } from '../../../modules/user/service/users.service';
import { APIOperableComponent } from '../api-operable/api-operable.component';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'reset-password-modal',
  templateUrl:
    './console/app-js/shared/components/reset-password-modal/reset-password-modal.component.html'
})
export class ResetPasswordModalComponent extends APIOperableComponent
  implements OnInit {
  @Input('user') user: any;
  @Input('opened') showResetPasswordModal = false;
  @Output() closed = new EventEmitter<any>();
  public isEmailSent: boolean = false;
  public resetPasswordUrl: string;
  public isUrlGenerated: boolean = false;
  public isUrlCopied: boolean = false;

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private usersService: UsersService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit() {}

  // Send password reset email
  public sendPasswordResetEmail(userId, email): void {
    this.usersService.changePasswordUser(userId, email).subscribe();
  }

  /**
   * Close password reset modal and send email
   * @param user
   */
  public submitPasswordReset(): void {
    this.sendPasswordResetEmail(this.user.id, this.user.email);
    this.isEmailSent = true;
    setTimeout(() => {
      this.isEmailSent = false;
    }, 5000);
  }

  // generate rest password URL
  public getResetPasswordUrl(userId) {
    this.usersService.getResetPasswordUrl(userId).subscribe(result => {
      this.resetPasswordUrl = result.resetPasswordUrl;
    });
  }

  public generateResetPasswordUrl() {
    this.getResetPasswordUrl(this.user.id);
    this.isUrlGenerated = true;
  }
  /**
   * Close and cancel password reset modal
   */
  public close() {
    this.showResetPasswordModal = false;
    this.isEmailSent = false;
    this.isUrlCopied = false;
    this.isUrlGenerated = false;
    this.closed.emit();
  }
  /**
   * copy resetPasswordUrl
   */
  public copyResetPasswordUrl(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.isUrlCopied = true;
    setTimeout(() => {
      this.isUrlCopied = false;
    }, 5000);
  }
}
